import { Teacher } from "@app/shared/types";

export const sortTeachersByLastName = (teacherList: Teacher[]) =>
    [...teacherList].sort((a, b) => {
        const aLastName = a.name.split(" ").pop() || "";
        const bLastName = b.name.split(" ").pop() || "";
        return aLastName.localeCompare(bLastName);
    });
